import service from '@/api/step';
import {handleError} from '@/state/generators/helpers';
import {loading} from "../generators/helpers";

let relatedStatusesPending = {};

function normalizeFilters(filters) {
    return JSON.stringify(Object.keys(filters).sort().reduce((acc, key) => {
        acc[key] = filters[key];
        return acc;
    }, {}))
}

export const state = {
    stepsWithProjectStepsLoading: false,
    stepsWithProjectSteps: [],
    service: service('steps/projects'),
    statuses: [],
    allStatuses: [],
    relatedStatusesCache: {}
}

export const getters = {
    stepsWithProjectStepsLoading: function (state) {
        return !!state.stepsWithProjectStepsLoading
    },
    stepsWithProjectSteps: function (state) {
        return state.stepsWithProjectSteps
    },
    statuses: (state) => state.statuses,
    allStatuses: (state) => state.allStatuses
}

export const mutations = {
    'SET_STEPS_WITH_PROJECT_STEPS_LOADING': function (state, boolean = true) {
        state.stepsWithProjectStepsLoading = boolean
    },

    'SET_STEPS_WITH_PROJECT_STEPS': function (state, list) {
        state.stepsWithProjectSteps = list
    },

    'SET_STATUSES': function (state, list = []) {
        state.statuses = list
    },

    'SET_ALL_STATUSES': function (state, list = []) {
        state.allStatuses = list
    },

    'SET_STATUS_INITIATORS': function (state, {data, index}) {
        if (!state.item.status_initiators) {
            state.item.status_initiators = [];
        }
        if (index === false) {
            state.item.status_initiators.push(data);
        } else {
            state.item.status_initiators[index] = Object.assign(state.item.status_initiators[index], data);
        }
    },

    'ADD_TO_STATUS_CACHE': function (state, {key, result}) {
        state.relatedStatusesCache[key] = {
            result: result.data,
            additional: result.additional,
            meta: result.data
        };
    },
}

export const actions = {
    steps: function ({commit, state}, filters) {
        commit('app/SET_LOADING', true, {root: true})
        commit('SET_STEPS_WITH_PROJECT_STEPS_LOADING', true)

        return state.service.fetchStepsWithProjectSteps(filters.project_id, filters).then(response => {
            commit('SET_STEPS_WITH_PROJECT_STEPS', response.data)
            commit('app/SET_LOADING', false, {root: true})
            commit('SET_STEPS_WITH_PROJECT_STEPS_LOADING', false)
            return response.data
        }).catch((e) => {
            handleError(e, commit)
        })
    },

    clearStepsWithProjectSteps: function ({ commit }) {
        commit('SET_STEPS_WITH_PROJECT_STEPS',[])
    },

    statuses: function ({commit, state, rootState}, payload) {
        const key = payload ? normalizeFilters(payload) : 'empty';

        if (state.relatedStatusesCache[key]) {
            return state.relatedStatusesCache[key];
        }

        loading(commit);

        if (relatedStatusesPending[key]) {
            return relatedStatusesPending[key];
        }

        const request = rootState.status.service.fetchAll(payload).then(response => {
            commit('SET_STATUSES', response.data);
            commit('ADD_TO_STATUS_CACHE', {key: key, result: response});
            loading(commit, false)
            return response.data
        }).catch((e) => {
            handleError(e, commit)
        });

        relatedStatusesPending[key] = request;

        return request;
    },

    allStatuses: function ({commit, rootState}, payload) {
        loading(commit)

        return rootState.status.service.fetchAll(payload).then(response => {
            commit('SET_ALL_STATUSES', response.data)
            loading(commit, false)
            return response.data
        }).catch((e) => {
            handleError(e, commit)
        })
    },

    clearStatuses: function ({commit}) {
        commit('SET_STATUSES', [])
    },

    clearAllStatuses: function ({commit}) {
        commit('SET_ALL_STATUSES', [])
    },

    setStatusInitiators: function ({commit}, {data, index}) {
        commit('SET_STATUS_INITIATORS', {data: data, index: index === -1 ? false : index})
    },
}
